<!--Login Page Starts-->

<div class="shape1"></div>
<div class="shape2"></div>
<div class="shape3"></div>
<div class="shape4"></div>
<section id="error">
    <div class="container-fluid">
      <div class="row auth-height full-height-vh">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="row">
            <div class="col-12 text-center">
              <img src="assets/img/loginpage.svg" alt="" class="img-fluid error-img mt-2 vert-move" height="300" width="400">
              <div class="w-75 error-text mx-auto mt-4">
                <!-- <p>نأسف لاأزعاجكم حدث خطا ما</p>
                <p></p> -->
              </div>
              <!-- <a [routerLink]="['/page/dashboard']" class="btn btn-warning my-2">Back To Home</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

